import { createGlobalStyle } from 'styled-components';


const GlobalStyle = createGlobalStyle`
  html, body {
      width: 100%;
      height: 100%;
      margin: 0;
      position: relative;
      background-color: #222f3e;
  }
`

export default GlobalStyle;